import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'next-common-lib';
import i18n from 'i18n';
import * as wizardActions from 'redux/ducks/common/wizardDuck';
import GnbViewBox from './GnbViewBox';

export const InputGnbMenuGroup = () => {
  const dispatch = useDispatch();
  const menuList = useSelector(state => state.menu.groupMenuList);
  return (
    <>
      <div>
        {menuList?.length === 0 ? (
          <Button
            componentType="normal"
            label={i18n.t('BTY_W_T_ADD_MENU_GROUP')}
            className="add"
            iconInfo={{ className: 'ic-plus ', size: 'sm' }}
            tabIndex={0}
            onClick={() => {
              dispatch(wizardActions.openPopup({ name: 'GNB' }));
            }}
          />
        ) : (
          menuList.map((item, idx) => {
            return <GnbViewBox item={item} key={idx} />;
          })
        )}
      </div>
    </>
  );
};

InputGnbMenuGroup.propTypes = {};
InputGnbMenuGroup.defaultProps = {};
export default InputGnbMenuGroup;
